import { IconSize, ShapeIcon } from '@ardoq/icons';
import styled from 'styled-components';
import { colors } from '@ardoq/design-tokens';

const ShapeIconOptionWrpper = styled.div`
  height: ${IconSize.LARGE}px;
  width: ${IconSize.LARGE}px;
`;

export const ShapeIconOption = ({
  shapeId,
  color,
}: {
  shapeId: string;
  color?: string;
}) => (
  <ShapeIconOptionWrpper>
    <ShapeIcon shapeName={shapeId} color={color || colors.icon} />
  </ShapeIconOptionWrpper>
);
